{
    let tabs = document.querySelectorAll('[data-tabs]');

    if (tabs !== null) {
        document.addEventListener('click', e => {
            if (!e.target.matches('[data-tabs] a')) {
                return;
            }

            e.preventDefault();

            let parent = e.target.closest('[data-tabs]');
            let content_slug = parent.getAttribute('id');
            let target_slug = e.target.getAttribute('href').substr(1);

            parent.querySelectorAll('a').forEach((link) => {
                link.classList.remove('is-active');
            });

            e.target.classList.add('is-active');

            let content = document.querySelector(`[data-tabs-content="${content_slug}"]`);

            content.querySelectorAll('.tabs-panel').forEach((el) => {
                el.classList.remove('is-active');
            });

            let tab = document.querySelector(`[data-tabs-content="${content_slug}"] .tabs-panel#${target_slug}`);
            tab.classList.add('is-active')
        });
    }
}
